import { Injectable } from '@angular/core';
import { APICacheService } from '@shared/services/api-cache.service';
import { CacheService } from '@shared/services/cache.service';
import { LanguageService } from '@shared/services/language.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(private apiCacheService: APICacheService,
    private cacheService: CacheService,
    private languageService: LanguageService) { }

  createAPICache(): Observable<any> {
    return this.apiCacheService.create().pipe(tap(() => this.finalizeCache()));
  }

  private finalizeCache() {
    this.cacheService.initPreference();
    this.languageService.languageType = this.cacheService.preference.languageType;
    this.cacheService.setTimestamp();
  }
}
